import { TDeviceType } from '@cian/ui-kit';
import { IAnalyticsPage } from '../../types/analytics';

interface IGetAnalyticsPageParams {
  pageNumber?: number;
  deviceType: TDeviceType;
}

/**
 * Возвращает данные аналитики для поля `page`.
 */
export const getAnalyticsPage = ({ pageNumber, deviceType }: IGetAnalyticsPageParams): IAnalyticsPage => {
  return {
    pageType: 'ProjectsListingCB',
    siteType: deviceType === 'phone' ? 'mobile' : deviceType,
    pageNumber,
  };
};
